class WCMiniCartItem extends HTMLElement {
  constructor() {
    super()

    this.key = this.dataset.key
    this.sectionId = this.dataset.sectionId
  }

  connectedCallback() {
    this.sellingPlanSelect = this.querySelector('[data-selling-plan-select]')
    this.sellingPlanAddButton = this.querySelector('[data-selling-plan-add]')
    this.removeButton = this.querySelector('[data-remove-item]')
    this.quantityInput = this.querySelector('[data-quantity-input]')
    this.adjustQuantityButtons = this.querySelectorAll('[data-adjust-quantity]')

    this.sellingPlanSelect?.addEventListener('change', this.changeSellingPlan.bind(this))
    this.sellingPlanAddButton?.addEventListener('click', this.changeSellingPlan.bind(this))
    this.removeButton?.addEventListener('click', this.removeItem.bind(this))
    this.quantityInput?.addEventListener('change', this.adjustQuantity.bind(this))
    this.adjustQuantityButtons?.forEach(button => {
      button.addEventListener('click', () => this.handleQuantityButton(button))
    })
  }

  disconnectedCallback() {
    this.sellingPlanSelect?.removeEventListener('change', this.changeSellingPlan.bind(this))
    this.sellingPlanAddButton?.removeEventListener('click', this.changeSellingPlan.bind(this))
    this.removeButton?.removeEventListener('click', this.removeItem.bind(this))
    this.quantityInput?.removeEventListener('change', this.adjustQuantity.bind(this))
    this.adjustQuantityButtons?.forEach(button => {
      button.removeEventListener('click', () => this.handleQuantityButton(button))
    })
  }

  async changeSellingPlan(event) {
    event.preventDefault()

    const updatedPlanId = (
      this.sellingPlanSelect?.value ??
      this.sellingPlanAddButton?.dataset.sellingPlanId ??
      null
    )

    await this.updateItem({
      selling_plan: updatedPlanId
    })
  }

  async adjustQuantity (event) {
    event.preventDefault()
    const maxQuantity = Number(this.quantityInput.max ?? 0)
    const quantityValue = this.quantityInput?.value ?? 0
    this.quantityInput.value = quantityValue > maxQuantity
      ? maxQuantity
      : quantityValue < 0
        ? 0
        : quantityValue

    await this.updateItem({
      quantity: this.quantityInput?.value ?? 0
    })
  }

  handleQuantityButton (button) {
    if (!this.quantityInput) { return null }
    const quantityAdjustment = Number(button.dataset?.adjustQuantity ?? 0)
    const currentQuantity = Number(this.quantityInput.value ?? 0)
    const maxMsgWrapper = this.querySelector('.mini-cart-item__quantity-btn__wrapper')
    this.quantityInput.value = currentQuantity + quantityAdjustment
    if (Number(this.quantityInput.value) === Number(this.quantityInput.max ?? 0)) {
      maxMsgWrapper.classList.add('is-max')
    } else {
      maxMsgWrapper.classList.remove('is-max')
    }
    this.quantityInput.dispatchEvent(new Event('change'))
  }

  async removeItem(event) {
    event.preventDefault()
    await this.updateItem({
      quantity: 0
    })
  }

  async updateItem(data) {
    try {
      this.classList.add('loading')
      const fetchBody = {
        id: this.key,
        ...data,
        sections: this.sectionId,
      }

      const fetchRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(fetchBody),
      })

      const dataJson = await fetchRes.json()

      this.updateCart(dataJson)

      return dataJson
    } catch (err) {
      this.classList.remove('loading')
      console.error(err)
      return null
    }
  }

  updateCart(dataJson = null) {
    window.dispatchEvent(new CustomEvent('MINI_CART_ACTION', {
      detail: {
        action: 'UPDATE',
        cartResponseJson: dataJson
      }
    }))
  }
}

if (typeof customElements.get('wc-mini-cart-item') === 'undefined') {
  customElements.define('wc-mini-cart-item', WCMiniCartItem);
}
